var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider } from '@material-ui/core/styles';
import ExpenseDialog from '../CreateDialogue/ExpenseDialog';
import EditExpenseDialog from '../EditDialogue/EditExpenseDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');


export default function ExpenseTable() {
	const [refresh, setRefresh] = React.useState(true);
    const [expenses, setExpenses] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {

        if (refresh) {
            fetch('/api/expenses', {
				 method: 'Get',
			})
                .then(res => res.json())
                .then(json => {
					setExpenses(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
            
    })
    
    const handleDialogCallback = (childData) => {
		fetch("/api/expenses", {
		method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "expenses": [{
					"Name": childData.Name,
		            "InvoiceID": childData.Invoice,
		            "LabID": childData.Lab,
		            "Comment": childData.Comment,
		            "Amount": parseFloat(childData.Amount).toFixed(2),
		            "Date": moment.utc(childData.Date)
                }]
            })
        })
        logger(childData);	
        setRefresh(true)
    };

    const handleEditCallback = (childData) => {
		fetch("/api/expenses", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "expenses": {
                    "ID": childData.ID,
                    "Name": childData.Name,
		            "InvoiceID": childData.Invoice,
		            "LabID": childData.Lab,
		            "Comment": childData.Comment,
		            "Amount": childData.Amount,
		            "Date": moment.utc(childData.Date)
                },
            })
        })
        logger(childData);
        setRefresh(true)
    };
    
    
    
    const columns = [];
	if (permissions.CreateExpense == 1) {
		const adminActions = {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditExpenseDialog handleEditCallback={handleEditCallback} data={expenses[dataIndex]} />
                        </div>
                    );
                }

            }
        };
		columns.push(adminActions);
	}
	const columns1 = [
        {
            name: "Name",
            label: "Expense Name",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "InvoiceNumber",
            label: "Invoice",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "LabName",
            label: "Lab",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Comment",
            label: "Comment",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                       parseFloat(expenses[dataIndex].Amount).toFixed(2)
                    );
                }
            }
        },
        {
            name: "Date",
            label: "Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(expenses[dataIndex].Date).format("MM/DD/YYYY")
                    );
                }
            }
        }
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('ExprowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('ExprowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	columns.push(...columns1);
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < expenses.length; i++) {
					var eachRow = data[i].data;
					eachRow[6] =  moment.utc(eachRow[6]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'Expenses.xlsx', columnIndexToRemove:0})
			return false;
		},
        customToolbar: () => permissions.CreateExpense===1 && !isLoading ? (<ExpenseDialog handleDialogCallback={handleDialogCallback} />):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="ExpensesTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Expense
                        </Typography>
                    }
                    data={isLoading ? [] :expenses}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
        </Box>
        
    );
}